<template>
  <div ref="grid" class="view-grid">
    <slot></slot>
  </div>
</template>

<script>
export default {
  name: 'Gall',

  data () {
    return {
      grid: null
    }
  },

  watch: {
    data: {
      deep: true,
      handler () {
        let self = this
        this.$nextTick().then(() => {
          self.resizeAllGridItems()
        })
      }
    }
  },

  mounted () {
    window.addEventListener('resize', this.resizeAllGridItems)
    this.grid = this.$refs.grid
    this.resizeAllGridItems()
  },

  updated () {
    this.resizeAllGridItems()
  },

  destroyed () {
    window.removeEventListener('resize', this.resizeAllGridItems)
  },

  methods: {
    resizeGridItem (item) {
      let imgEls = item.querySelectorAll('img')

      if (imgEls.length > 0) {
        let self = this

        let promises = []
        for (let i = 0; i < imgEls.length; i++) {
          promises.push(new Promise((resolve, reject) => {
            imgEls[i].onload = () => {
              resolve({ status: 'ok' })
            }
          }))

          Promise.all(promises).then(() => {
            let rowHeight = parseInt(window.getComputedStyle(self.grid).getPropertyValue('grid-auto-rows'))
            let rowGap = parseInt(window.getComputedStyle(self.grid).getPropertyValue('grid-row-gap'))
            let rowSpan = Math.ceil((item.querySelector('.content').getBoundingClientRect().height + rowGap) / (rowHeight + rowGap))

            item.style.gridRowEnd = 'span ' + rowSpan
          })
        }
      } else {
        let rowHeight = parseInt(window.getComputedStyle(this.grid).getPropertyValue('grid-auto-rows'))
        let rowGap = parseInt(window.getComputedStyle(this.grid).getPropertyValue('grid-row-gap'))
        let rowSpan = Math.ceil((item.querySelector('.content').getBoundingClientRect().height + rowGap) / (rowHeight + rowGap))
        item.style.gridRowEnd = 'span ' + rowSpan
      }
    },

    resizeAllGridItems () {
      let allItems = document.getElementsByClassName('item')
      for (let x = 0; x < allItems.length; x++) {
        this.resizeGridItem(allItems[x])
      }
    }
  }
}
</script>

<style lang="scss">
// @import "@/styles/styles.scss";

.view-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(240px, 1fr));
  grid-gap: 15px;
  grid-auto-rows: 10px; // tämä masonrya varten
  #home & { grid-template-columns: repeat(auto-fill, minmax(240px, 1fr)); }
  #example & { grid-template-columns: repeat(auto-fill, minmax(300px, 1fr)); }
  // #means & { max-width: 600px; }
  // #examples & {}
}
</style>
